import { render, staticRenderFns } from "./NsCurrencyTextField.vue?vue&type=template&id=6aa24409&"
import script from "./NsCurrencyTextField.vue?vue&type=script&lang=js&"
export * from "./NsCurrencyTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aa24409')) {
      api.createRecord('6aa24409', component.options)
    } else {
      api.reload('6aa24409', component.options)
    }
    module.hot.accept("./NsCurrencyTextField.vue?vue&type=template&id=6aa24409&", function () {
      api.rerender('6aa24409', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsCurrencyTextField.vue"
export default component.exports